<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">

        <div class="row">
            <div class="col-12">
                <h1 class="title-default">Logs de Integração</h1>
                <p>Consulte aqui o histórico de requisições das APIs de integração</p>
            </div>
        </div>
        <form class="form" [formGroup]="model" (ngSubmit)="clickPesquisar()" class="search-area card-section">
            <div class="row">
                <div class="col-12 col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Pesquisa</mat-label>
                        <input matInput type="text" formControlName="textoBusca">
                        <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-6">
                    <button mat-stroked-button type="button" class="btn-filter margin-right-15"
                        [matMenuTriggerFor]="filtroMenu" [matMenuTriggerFor]="filtroMenu"
                        [matBadge]="qtdFiltrosAvancados" matBadgeColor="warn"
                        [matBadgeHidden]="qtdFiltrosAvancados === 0">
                        <mat-icon>filter_list</mat-icon>
                        Filtrar
                    </button>
                    <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
                        <div class="filter-menu-content">
                            <div (click)="$event.stopPropagation()">
                                <h6>Filtros Avançados</h6>

                                <div class="filter-menu__form">
                                    <!-- Vendedor -->
                                    <mat-form-field appearance="outline">
                                        <mat-label>Requisição</mat-label>
                                        <mat-select formControlName="idUri">
                                            <mat-option>Todos</mat-option>
                                            @for(req of listaUri; track req.idUri){
                                            <mat-option [value]="req.idUri">
                                                <span>{{ req.verboHttp }}</span>
                                                <span class="detalhe">{{ req.descricao }}</span>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline">
                                        <mat-label>Status</mat-label>
                                        <mat-select formControlName="idTipoLog">
                                            <mat-option>Todos</mat-option>
                                            @for(status of listaTipoLog; track status.idTipoLog){
                                            <mat-option [value]="status.idTipoLog">{{ status.descricao }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Data da Requisição</mat-label>
                                        <input matInput formControlName="dataInicioRequest" placeholder="Data inicial"
                                            [matDatepicker]="picker">
                                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>


                            <div class="filter-menu__actions">
                                <button mat-button class="btn-secondary" matMenuClose>Cancelar</button>
                                <button mat-flat-button class="btn-primary" (click)="clickPesquisar()"
                                    matMenuClose>Aplicar</button>
                            </div>

                        </div>
                    </mat-menu>
                    <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
                        <mat-icon>cleaning_services</mat-icon>
                        Limpar Filtros
                    </button>
                </div>
            </div>

        </form>

        @if(this.listaLogsResponse && this.listaLogsResponse.listaLogIntegracao.length > 0){
        <table mat-table [dataSource]="_dataSource">

            <ng-container matColumnDef="metodoUri">
                <th mat-header-cell *matHeaderCellDef> Método - URI </th>
                <td mat-cell *matCellDef="let element">{{element.verboHttp}} - {{element.descricaoUri}} </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let element"> {{element.tipoLog}} </td>
            </ng-container>

            <ng-container matColumnDef="dataRequisicao">
                <th mat-header-cell *matHeaderCellDef> Data da requisição </th>
                <td mat-cell *matCellDef="let element"> {{element.datetimeInicioRequest | date:'dd/MM/yyyy HH:mm:ss'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="action-view">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    <a mat-mini-fab aria-label="Visualizar" class="fab-action default"
                        [routerLink]="['/integracao/logs/detalhe', {idLogIntegracao: element.idLogIntegracao}]">
                        <mat-icon>visibility</mat-icon>
                    </a>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div class="col-12 text-center ver-mais-pesquisa">
            <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (_isLoading === true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
                @else{
                <span class="material-symbols-outlined">keyboard_arrow_down</span>
                Ver mais
                }
            </button>
        </div>
        } @else if(_isLoading) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else {
        <app-empty-list [title]="'Nenhum log encontrado para os filtros informados'"></app-empty-list>
        }
    </div>
</div>